// Queries
import customerSearch from "./CustomerSearchQuery.gql";

export const Query = {
    customerSearch,
};
